import { Component } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-user-manage',
    templateUrl: './breadcrumb.user.manage.component.html'
})

export class BreadcrumbUserManageComponent { }
